import { useState, useEffect, useRef } from 'react';
import * as React from 'react';
import { Dimensions, BackHandler, SafeAreaView, Platform, NativeModules, AppState, Text } from 'react-native';
import { Icon, Spinner } from 'native-base';
import { enableScreens } from 'react-native-screens';
//import { NavigationActions, createAppContainer, createSwitchNavigator } from 'react-navigation';

//import { createMaterialTopTabNavigator } from 'react-navigation-tabs';
//, createDrawerNavigator as rncreateDrawerNavigator
//import { createBrowserApp } from '@react-navigation/web';
import { NavigationContainer, useLinking, getStateFromPath, getPathFromState } from '@react-navigation/native';
//import { createDrawerNavigator as drcreateDrawerNavigator } from 'react-navigation-drawer'; //this should be from above but laggy
import { createDrawerNavigator } from '@react-navigation/drawer';
import { createStackNavigator } from '@react-navigation/stack';
import { createMaterialBottomTabNavigator } from '@react-navigation/material-bottom-tabs';
import * as Linking from 'expo-linking';
import Constants from 'expo-constants';

import LocalStorage from './api/LocalStorage';

import Redirect from './Redirect';

import { Root } from 'native-base';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import useSidebarStyle from './hooks/sidebarStyle';
import CustomDrawerContent from './components/Sidebar/drawerContent';
import TaxOnlyDrawerContent from './components/Sidebar/taxOnlyDrawer';

//screenss
import Login from './screens/Login';

import Dashboard from './screens/Dashboard';
//import Sidebar from './components/Sidebar';
import Pin from './screens/Pin';
//import CameraScreen from './stories/screens/Camera';
import PeopleTabs from './screens/PeopleTabs';
import DailyEntries from './screens/DailyEntries';
import PersonDetails from './screens/PersonDetails';
import DEformContainer from './screens/DEform/DEformContainer';
import InvoiceFormContainer from './screens/InvoiceForm/InvoiceFormContainer';
import SettingsContainer from './screens/Settings';
import Intro from './screens/Intro';
import SignUpContainer from './screens/Signup/signupContainer';
import SubscriptionContainer from './screens/Subscription/subscriptionContainer';
import DECamera from './screens/DEform/DECamera';
import Report from './screens/Reports/reportContainer';
import Budgets from './screens/Settings/budgets';
import DemoSelect from './screens/Intro/demoSelect';
import VatContainer from './screens/Vat/vatContainer';
import VatDetails from './screens/Vat/vatDetails';
import ProfileContainer from './screens/Profile/profileContainer';
import Reports from './screens/Reports/reportsContainer';
import SaDetailContainer from './screens/SA/saDetailContainer';
import SaFormContainer from './screens/SA/saFormContainer';
import BankImport from './screens/BankImport/bankImport';

import TaxYearList from './screens/Reports/taxYearList';

import Alert from './components/alert';

//const prefix = Linking.makeUrl('/');

const deviceWidth = Dimensions.get('window').width;
const deviceHeight = Dimensions.get('window').height;
//const createDrawerNavigator = drcreateDrawerNavigator; //Platform.OS == 'web' ? rncreateDrawerNavigator : drcreateDrawerNavigator;
const Drawer = createDrawerNavigator();
const Tab = createMaterialBottomTabNavigator();
const Stack = createStackNavigator();

const isWeb = Platform.OS == 'web';

enableScreens();
/*
const RightDrawer = createDrawerNavigator(
	{
		Drawer: Drawer
	},
	{
		contentComponent: DECamera,
		//drawerType: 'back',
		drawerPosition: 'right',
		//edgeWidth: 40 - deviceWidth,
		drawerWidth: Math.min((deviceHeight - 45) / 1.7, deviceWidth) //16x9
	}
);
*/
//const LoggedInApp = LeftDrawer; //Platform.OS == 'web' ? LeftDrawer : RightDrawer;

export function App(props) {
	const dispatch = useDispatch();
	const { user, jwt, userInfo } = useSelector(
		state => ({
			user: state.loginReducer.user,
			jwt: state.loginReducer.jwt,
			userInfo: state.loginReducer.userInfo
		}),
		shallowEqual
	);
	const isWeb = Platform.OS == 'web';
	const prefixes = isWeb ? ['http://localhost:19006', 'https://app.calc.al'] : ['calcal://'];
	const taxOnly = userInfo && userInfo.user && userInfo.user.taxOnly;
	const layout = taxOnly
		? {
				prefixes,
				config: {
					Main: {
						path: '',
						initialRouteName: 'Years',
						screens: {
							Years: 'SelectYear',
							SaDetails: 'SaDetails/:year',
							SaForm: 'saForm/:y/:year/:form'
						}
					},
					Profile: 'Profile',
					SubscriptionContainer: 'Subscription',
					Pin: 'ChangePIN/:reason/:reset',
					Redirect: 'redirect'
				}
		  }
		: {
				prefixes,
				config: {
					Main: {
						path: '',
						initialRouteName: 'TabNav',
						screens: {
							Entry: 'DailyEntry',
							PersonDetails: 'People/:personType/:personId',
							Report: 'Report/:report',
							Invoice: 'invoice',
							BankImport: 'BankImport',
							Vat: 'vat',
							VatDetails: 'vatDetails',
							SaDetails: 'SaDetails/:year',
							SaForm: 'saForm/:y/:year/:form',
							TabNav: {
								path: '',
								initialRouteName: 'Dashboard',
								screens: {
									DailyEntries: 'DailyEntries',
									Dashboard: 'Dashboard',
									People: 'People',
									Reports: 'Reports'
								}
							}
						}
					},
					Settings: 'Settings',
					Budgets: 'Budgets',
					Profile: 'Profile',
					SubscriptionContainer: 'Subscription',
					Pin: 'ChangePIN',
					Redirect: 'redirect'
				} /*,
				getStateFromPath: (path, options) => {
					console.log('------ PATH -> STATE ------');
					// Return a state object here
					// You can also reuse the default logic by importing `getStateFromPath` from `@react-navigation/native`
					const sta = getStateFromPath(path, options);
					console.log('------ PATH -> STATE ------', path, options, sta);

					return sta;
				},
				getPathFromState: (state, config) => {
					console.log('------ STATE -> PATH ------');
					// Return a path string here
					// You can also reuse the default logic by importing `getPathFromState` from `@react-navigation/native`
					const path = getPathFromState(state, config);
					console.log('------ STATE -> PATH ------', state, config, path);
					return path;
				}*/
		  };

	const [isReady, setIsReady] = React.useState();
	const [initialState, setInitialState] = useState();

	React.useEffect(() => {
		const restoreState = async () => {
			try {
				const initialUrl = await Linking.getInitialURL();
				console.log('initialUrl', initialUrl);

				if (!isWeb || initialUrl === null) {
					// Only restore state if there's no deep link and we're not on web
					const savedState = await LocalStorage.getNavState();

					if (savedState !== undefined) {
						setInitialState(savedState);
					}
				}
			} finally {
				setIsReady(true);
			}
		};

		if (!isReady) restoreState();
	}, [isReady]);

	useEffect(() => {
		AppState.addEventListener('change', handleAppStateChange);

		return () => {
			AppState.removeEventListener('change', handleAppStateChange);
		};
	}, []);

	useEffect(() => {
		if (isWeb) {
			// nasty hack to work around https://github.com/GeekyAnts/NativeBase-KitchenSink/issues/81
			const brokenActionSheetOnWeb = document.querySelector('#root > div > div > div > div +div:nth-child(2)');
			if (brokenActionSheetOnWeb) {
				brokenActionSheetOnWeb.style.display = 'none';
			}
		}
	});

	const handleAppStateChange = async nextAppState => {
		console.log('App has become ' + nextAppState);

		//check props.user.refreshTime, props.jwt.expires
		const currTime = new Date().getTime() / 1000;
		if (nextAppState == 'active' && jwt && jwt.expires < currTime + 60) {
			console.log('JWT expired. Back to PIN');
			dispatch({
				type: 'SET_JWT',
				token: {},
				info: null
			});
		}

		if (nextAppState == 'active' && user && user.refreshTime < currTime + 300) {
			console.log('WP Token expired...');
			const signedIn = await LocalStorage.getUserAsync(); //will refresh for us and save it
			signedIn &&
				dispatch({
					type: 'SET_USER',
					user: signedIn
				});
		}
	};

	const { drawerType } = useSidebarStyle();

	__DEV__ && console.log(Platform.OS, drawerType, initialState, taxOnly, layout);

	__DEV__ && console.log('App.js gets user, jwt', user, jwt);

	let loggedInState = null;

	if (!user) {
		console.log('No user -> Intro');
		return (
			<NavigationContainer key="intros">
				<Stack.Navigator mode="modal" headerMode="none" initialRouteName="Intro">
					<Stack.Screen name="Intro" component={Intro} />
					<Stack.Screen name="Login" component={Login} />
					<Stack.Screen name="SignUpContainer" component={SignUpContainer} />
					<Stack.Screen name="DemoSelect" component={DemoSelect} />
				</Stack.Navigator>
			</NavigationContainer>
		);
	} else if (!jwt || !jwt.token) {
		console.log('No JWT -> PIN');
		return (
			<NavigationContainer key="pins">
				<Stack.Navigator mode="modal" headerMode="none" initialRouteName="Pin">
					<Stack.Screen name="Pin" component={Pin} />
					<Stack.Screen name="Profile" component={ProfileContainer} />
				</Stack.Navigator>
			</NavigationContainer>
		);
	} else if (!isReady) {
		return <Text>Handling link...</Text>;
	} else if (taxOnly) {
		__DEV__ && console.log('Rendering taxOnly; initialState', initialState, userInfo);
		return (
			<NavigationContainer key="taxalls" initialState={initialState} onStateChange={state => LocalStorage.saveNavState(state)} linking={layout} fallback={<Text>Loading…</Text>}>
				<Drawer.Navigator
					drawerType={drawerType}
					drawerPosition="left"
					drawerContent={props => <TaxOnlyDrawerContent {...props} user={user} fixed={drawerType == 'permanent'} />}
					drawerContentOptions={{
						activeTintColor: '#438eb9',
						inactiveTintColor: 'rgba(0, 0, 0, .87)',
						itemStyle: { marginVertical: 30 }
					}}
					screenOptions={isWeb ? { gestureEnabled: true, animationEnabled: false } : {}}
					drawerStyle={drawerType == 'permanent' && { paddingTop: 0, width: 280, position: 'absolute', top: 0, bottom: 0 }}
					sceneContainerStyle={drawerType == 'permanent' ? { position: 'absolute', left: 280, height: '100%', right: 0 } : null}>
					<Drawer.Screen name="Main">
						{({ navigation }) => (
							<Stack.Navigator
								key="stackNav"
								headerMode="none"
								screenOptions={{
									//headerStyleInterpolator: HeaderStyleInterpolators.forUIKit,
									animationEnabled: !isWeb
								}}>
								<Stack.Screen
									name="Years"
									component={TaxYearList}
									/*options={{
									title: 'Examples',
									headerLeft: drawerType == 'permanent' ? undefined : () => <Appbar.Action color="#FFF" icon="menu" onPress={() => navigation.toggleDrawer()} />
								}}*/
									//initialParams={{ desc: 'Tax Return', report: 'TaxForecast', rptFilter: false, url: 'TaxForecast' }}
								/>
								<Stack.Screen name="SaDetails" component={SaDetailContainer} />
								<Stack.Screen name="SaForm" component={SaFormContainer} />
							</Stack.Navigator>
						)}
					</Drawer.Screen>
					<Drawer.Screen name="Profile" component={ProfileContainer} />
					<Drawer.Screen name="SubscriptionContainer" component={SubscriptionContainer} />
					<Drawer.Screen name="Pin" component={Pin} />
					<Drawer.Screen name="Redirect" component={Redirect} />
				</Drawer.Navigator>
			</NavigationContainer>
		);
	} else {
		//normal not tax only
		__DEV__ && console.log('Rendering; initialState', initialState);

		return (
			<NavigationContainer key="alls" initialState={initialState} linking={layout} onStateChange={state => LocalStorage.saveNavState(state)} fallback={<Text>Loading…</Text>}>
				<Drawer.Navigator
					drawerType={drawerType}
					//minSwipeDistance={300} - these don't work on web :(
					//edgeWidth={-100}
					drawerContent={props => <CustomDrawerContent {...props} user={user} fixed={drawerType == 'permanent'} />}
					drawerContentOptions={{
						activeTintColor: '#438eb9',
						inactiveTintColor: 'rgba(0, 0, 0, .87)',
						itemStyle: { marginVertical: 30 }
					}}
					initialRouteName="Main"
					screenOptions={isWeb ? { gestureEnabled: true, animationEnabled: false } : {}}
					drawerStyle={{ paddingTop: 0, width: 280, position: 'absolute', top: 0, bottom: 0 }}
					sceneContainerStyle={drawerType == 'permanent' ? { position: 'absolute', left: 280, height: '100%', right: 0 } : null}>
					<Drawer.Screen name="Main">
						{({ navigation }) => (
							<Stack.Navigator key="stackNav" headerMode="none" mode="card" defaultNavigationOptions={{ gesturesEnabled: true, animationEnabled: !isWeb }} initialRouteName="TabNav">
								<Stack.Screen name="TabNav">
									{({ navigation }) => (
										<Tab.Navigator
											key="tabNav"
											shifting
											backBehavior="history"
											tabBarOptions={{ showIcon: true }}
											barStyle={drawerType == 'permanent' ? { height: 0 } : {}}
											screenOptions={{ animationEnabled: !isWeb, swipeEnabled: !isWeb }}
											initialRouteName="Dashboard">
											<Tab.Screen
												name="Dashboard"
												component={Dashboard}
												options={{ tabBarColor: '#22485e', tabBarIcon: ({ focused, size }) => <Icon name="apps" style={{ color: focused ? 'white' : '#c7ddeb', fontSize: 22 }} /> }}
											/>

											<Tab.Screen
												name="DailyEntries"
												component={DailyEntries}
												options={{
													tabBarColor: '#002d47',
													tabBarIcon: ({ focused, size }) => <Icon name="calendar" style={{ color: focused ? 'white' : '#c7ddeb', fontSize: 22 }} />
												}}
											/>

											<Tab.Screen
												name="People"
												component={PeopleTabs}
												options={{ tabBarColor: '#1c6691', tabBarIcon: ({ focused, size }) => <Icon name="people" style={{ color: focused ? 'white' : '#c7ddeb', fontSize: 22 }} /> }}
											/>
											<Tab.Screen
												name="Reports"
												component={Reports}
												options={{ tabBarIcon: ({ focused, size }) => <Icon name="document" style={{ color: focused ? 'white' : '#c7ddeb', fontSize: 22 }} />, tabBarColor: '#2c424f' }}
											/>
										</Tab.Navigator>
									)}
								</Stack.Screen>
								<Stack.Screen name="Report" component={Report} />
								<Stack.Screen name="TaxYears" component={TaxYearList} />
								<Stack.Screen name="PersonDetails" component={PersonDetails} />
								<Stack.Screen name="Entry" component={DEformContainer} />
								<Stack.Screen name="BankImport" component={BankImport} />
								<Stack.Screen name="Invoice" component={InvoiceFormContainer} />
								<Stack.Screen name="Vat" component={VatContainer} />
								<Stack.Screen name="VatDetails" component={VatDetails} />
								<Stack.Screen name="SaDetails" component={SaDetailContainer} />
								<Stack.Screen name="SaForm" component={SaFormContainer} />
							</Stack.Navigator>
						)}
					</Drawer.Screen>
					<Drawer.Screen name="Settings" component={SettingsContainer} />
					<Drawer.Screen name="Budgets" component={Budgets} />
					<Drawer.Screen name="Profile" component={ProfileContainer} />
					<Drawer.Screen name="SubscriptionContainer" component={SubscriptionContainer} />
					<Drawer.Screen name="Pin" component={Pin} />
					<Drawer.Screen name="Redirect" component={Redirect} />
				</Drawer.Navigator>
			</NavigationContainer>
		);
	}
}
